import { Address } from "viem";

export const bentoUSDAddresses: Record<string, Address> = {
  prod: "0xd09e683134D1BA8a80a26F357539Ae08d3Fb27C1",
  stage: "0xd09e683134D1BA8a80a26F357539Ae08d3Fb27C1",
  fork: "0x6ae08082387AaBcA74830054B1f3ba8a0571F9c6",
};

export const bentoUSDPlusAddresses: Record<string, Address> = {
  prod: "0xb7aF741Ab2a2f05f4Ad0851a848Aa4F651eFC1E0",
  stage: "0xb7aF741Ab2a2f05f4Ad0851a848Aa4F651eFC1E0",
  fork: "0x1f26Cb844f42690b368f99D3d6C75DBe205f7732",
};

export const tellerAddresses: Record<string, Address> = {
  fork: "0xE82E67F347826a9ADb4bdFD1294126593d933722",
};
